Postlogin = (function (postlogin) {
    postlogin.AssessmentStudentProgress = {};
    const self = postlogin.AssessmentStudentProgress;

    const $studentProgressTable = $('#student-progress-table');
    const progressBars = [];

    const setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const userId = $(this).attr('data-user-id');
                const bar = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#eee',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    // eslint-disable-next-line no-shadow
                    step(state, bar) {
                        bar.path.setAttribute('stroke', state.color);
                        bar.setText(`${Math.round(bar.value() * 100)} %`);
                    },
                });
                bar.animate(progress / 100); // Value from 0.0 to 1.0
                progressBars[userId] = bar;
            });
        }
    };

    const initBootstrapTable = function () {
        const assessmentId = $studentProgressTable.data('assessment-id');

        const columns = [
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned By',
                field: 'teacher_id',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Student',
                field: 'student',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned',
                field: 'date_assigned',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value, row) => {
                    let progressIndicator = '';
                    if (+row.progress === 100) progressIndicator = 'fa-square-check text-success';
                    if (row.progress < 100 && row.progress > 33) progressIndicator = 'fa-square';

                    return `<i class="fa-regular ${progressIndicator} aria-hidden="true" />`;
                },
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value, row) => `
                        <div class="progress-indicator hidden-print"
                            id="student-progress-${row.student_id}-${row.assignment_id}-${row.assessment_id}"
                            data-progress="${row.progress}"
                            data-user-id="${row.student_id}"
                        </div>
                        <span class="visible-print">${row.progress}%</span>
                    `,
            },
            {
                title: '',
                field: 'actions',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
        ];

        $studentProgressTable.bootstrapTable({
            formatNoMatches() {
                return 'No activity to show';
            },
            classes: 'table table-hover table-condensed',
            striped: true,
            showRefresh: false,
            showToggle: false,
            showColumns: false,
            showPaginationSwitch: false,
            idField: 'activity_id',
            minimumCountColumns: '2',
            pagination: true,
            search: true,
            sortName: 'date_assigned',
            sortOrder: 'desc',
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            searchAlign: 'left',
            clickToSelect: false,
            maintainSelected: false,
            sidePagination: 'server',
            url: `/assessments/${assessmentId}/json/`,
            pageSize: 25,
            queryParamsType: 'other',
            queryParams(params) {
                const searchParams = {};
                searchParams.search_term = params.searchText;
                searchParams.page = params.pageNumber;
                searchParams.page_size = params.pageSize;
                searchParams.order_by = params.sortName;
                searchParams.sort_order = params.sortOrder;

                return searchParams;
            },
            columns,
            responseHandler(res) {
                // TODO: move all this into the columns above.
                const formattedResult = {};
                formattedResult.total = res.meta.total;
                formattedResult.rows = res.data;

                $(formattedResult.rows).each((i, result) => {
                    let row = result;
                    row.student_id = row.user_id;

                    // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                    row = Jr.Utils.convertRowDate(row, 'llll', []);

                    row.teacher_id = `${row.teacher_first_name} ${row.teacher_last_name}`;

                    const assignmentViewUrl = $studentProgressTable
                        .attr('data-assignment-view-url')
                        .replace(':assessment_id', row.assessment_id)
                        .replace(':assignment_id', row.assignment_id);
                    row.date_assigned = `<a href="${assignmentViewUrl}">${row.date_assigned}</a>`;

                    const userViewUrl = $studentProgressTable.attr('data-user-view-url').replace(':user_id', row.user_id);
                    let name = $.trim(`${row.first_name} ${row.last_name}`);
                    if (name !== '') {
                        name += '<br>';
                    }
                    row.student = `<a href="${userViewUrl}">${name}(${row.username})</a>`;

                    row.actions = '';
                    if (row.progress > 0) {
                        const assessmentViewUrl = $studentProgressTable
                            .attr('data-ccis-assessment-view-url')
                            .replace(':user_id', row.user_id)
                            .replace(':user_assessment_id', row.user_assessment_id);
                        row.actions += `<a href="${assessmentViewUrl}" class="btn btn-hollow-pink">See ${
                            +row.progress === 100 ? '' : 'Partial '
                        }Results</a>`;
                    }
                });

                return formattedResult;
            },
            onLoadSuccess() {
                setupProgressBars();
            },
            rowStyle(row) {
                let classes = '';
                if (row.progress < 33.3333) {
                    classes += 'danger ';
                } else if (row.progress < 66.6666) {
                    classes += 'warning ';
                } else if (row.progress < 100) {
                    classes += 'info ';
                } else {
                    classes += 'success ';
                }

                return {
                    classes,
                };
            },
        });
    };

    self.init = function () {
        initBootstrapTable();
    };

    return postlogin;
}(Postlogin || {}));
